import React, { useCallback } from 'react'
import { Divider, Drawer, Modal } from 'antd'
import BaseButton from 'widgets/BaseButton'
import { CloseOutlined } from '@ant-design/icons'
import { useTranslation } from 'contexts/Localization'

import { useMatchBreakpoints } from '../../packages/uikit/src/hooks'

interface ModalConfirmProps {
  visible?: boolean
  onClose?: () => void
  title: string
  onOk?: () => void
  okText?: string
  cancelText?: string
  footer?: JSX.Element | false
}

const ModalConfirm: React.FC<ModalConfirmProps> = ({
  visible,
  onClose,
  title,
  onOk,
  okText,
  cancelText,
  footer,
  children,
}) => {
  const { isMobile } = useMatchBreakpoints()
  const { t } = useTranslation()

  const renderContent = useCallback(() => {
    return (
      <>
        <div className="hidden md:block">
          <h1 className="text-xl font-bold">{title}</h1>
          <Divider />
        </div>

        {typeof children === 'string' ? <p className="text-center my-7 md:mt-10 md:mb-3">{children}</p> : children}

        {footer === false
          ? null
          : footer || (
              <div className="grid grid-cols-2 gap-5 mt-10">
                <BaseButton onClick={onClose} secondary>
                  {cancelText ?? t('Cancel')}
                </BaseButton>
                <BaseButton onClick={onOk}>{okText ?? t('Ok')}</BaseButton>
              </div>
            )}
      </>
    )
  }, [cancelText, children, footer, okText, onClose, onOk, t, title])

  if (isMobile)
    return (
      <Drawer
        title={
          <div className="flex items-center justify-between">
            <h1 className="text-xl font-bold">{title}</h1>
            <CloseOutlined onClick={onClose} className="text-xl" rev={undefined} />
          </div>
        }
        closable={false}
        height="auto"
        placement="bottom"
        onClose={onClose}
        open={visible}
      >
        {renderContent()}
      </Drawer>
    )

  return (
    <Modal onCancel={onClose} footer={false} centered open={visible}>
      {renderContent()}
    </Modal>
  )
}

export default ModalConfirm
